module.exports = __webpack_public_path__ + "img/level2addon_mining_hands_shadow.6f722cf0.png";